import type { ReactNode, SVGProps } from 'react';
import { cn } from '@/helpers/classnames';

export type IconProps = Omit<SVGProps<SVGSVGElement>, 'children'>;

/**
 * Builds a plain SVG icon component. Icons render at 24px and take their color
 * from the surrounding text, so callers size and tint them with Tailwind.
 */
export const createIcon = (
  displayName: string,
  glyph: ReactNode,
  svgProps?: SVGProps<SVGSVGElement>,
): React.FC<IconProps> => {
  const Icon: React.FC<IconProps> = ({ className, ...props }) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...svgProps}
      className={cn('size-6 shrink-0', className)}
      {...props}
    >
      {glyph}
    </svg>
  );
  Icon.displayName = displayName;
  return Icon;
};
